import { custData } from "src/shared/services/interface";
import api from "../../../../../features/auth/axiosConfig";
import { errorHandling } from "src/shared/utils/errorHandling";

export const getOrdersApi = (orderid: string) => {
  return api
    .get(`/app/v1/pos/order/${orderid}?pageNumber=""&pageSize=""`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error("getOrdersApi Error:", err);
      throw err;
    });
};

export const getCustomerByPhoneApi = (filteredTerm: string, customerId: string | number, pagenumber: number) => {
  return api
    .get(`/app/v1/pos/customer?include_deleted=False&pageNumber=${pagenumber}&pageSize=${10}&searchBy=${filteredTerm}/${customerId}`)
    .then((res) => {
      console.log("getCustomerByPhoneApi Success:", res.data);
      return res;
    })
    .catch((err) => {
      console.error("getCustomerByPhoneApi Error:", err);
      throw err;
    });
};

export const getLedgerByCustomerIdApi = (customerid: string) => {
  return api
    .get(`/pos/ledger/customer/${customerid}?pageNumber=""&pageSize=""`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error("getLedgerByCustomerIdApi Error:", err);
      throw err;
    });
};

export const updateCustomerEmailApi = async (customerId: string, email: custData) => {
  return api
    .put(`/app/v1/pos/customer/${customerId}`, email)
    .then((res) => {
      console.log("updateCustomerEmailApi Success:", res.data);
      return res;
    })
    .catch((err) => {
      errorHandling(err);
    });
};

export const cancelOrderApi = async (orderid: string | undefined, adjust_type: string) => {
  return api
    .put(`/app/v1/pos/cancel_order?orderid=${orderid}`, {
      OrderStatus: "Cancelled",
      adjust_type,
    })
    .then((res) => {
      console.log("cancelOrderApi Success:", res.data);
      return res;
    })
    .catch((err) => {
      console.error("cancelOrderApi Error:", err);
      throw err;
    });
};

export const updateOrderStatusApi = (orderid: string | undefined, orderStatus: string) => {
  const order = { OrderStatus: orderStatus, status_change: true };

  return api
    .patch(`/app/v1/pos/order/${orderid}`, order)
    .then((res) => {
      console.log("updateOrderStatusApi Success:", res.data);
      return res;
    })
    .catch((err) => {
      console.error("updateOrderStatusApi Error:", err);
      throw err;
    });
};

// export const fetchCustomerByIdApi = (customerId: string | number) => {
//   return api.get(`/app/v1/pos/customer?id=${customerId}`);
// };
